import React from 'react';
import { FaSearch } from 'react-icons/fa';

type SearchBarProps = {
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  placeholder?: string;
  className?: string;
  label?: string;
  showLabel?: boolean;
  required?: boolean;
};

const SearchBar: React.FC<SearchBarProps> = ({
  value = '',
  onChange,
  onKeyDown,
  placeholder = 'Search...',
  className = '',
  label = 'Search',
  showLabel = true,
  required = true,
}) => {
  return (
    <div className={`flex flex-col ${className}`}>
      {showLabel && (
        <label className="text-sm text-gray-600 font-medium mb-1">
          {label} {required && <span className="text-red-500">*</span>}
        </label>
      )}
      <div className="relative">
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <FaSearch className="text-gray-400" size={16} />
        </div>
        <input
          type="text"
          value={value}
          onChange={onChange}
          onKeyDown={onKeyDown}
          placeholder={placeholder}
          className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
        />
      </div>
    </div>
  );
};

export default SearchBar;
